export default "__VITE_ASSET___wJhQu0K__"